import React, { PureComponent } from "react";
import { Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { createOAuthClient } from "@axioscode/api-client/lib/utils/auth";

import { updateClient } from "auth/actions";
import { OAUTH, BACKEND_ROOT } from "config/constants";

const mapStateToProps = state => ({
  isAuthenticated: state.isAuthenticated,
});

const mapDispatchToProps = {
  updateClient,
};

class Login extends PureComponent {
  render() {
    const { from } = this.props.location.state || { from: { pathname: "/" } };
    const { isAuthenticated } = this.props;

    // If we're authenticated, redirect to the page that sent us here.
    // If not, redirect to the OAuth login page to start an auth token flow
    if (isAuthenticated) {
      return <Redirect to={from} />;
    } else {
      const client = createOAuthClient(
        OAUTH.CLIENT_ID,
        BACKEND_ROOT,
        OAUTH.SCOPES
      );
      this.props.updateClient(client);
      window.location.replace(client.token.getUri());
      return null; // This line won't ever be reached, but React requires it.
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);
